import { Field, ID, Int, ObjectType } from 'type-graphql'
import { Prop, PropType } from '@typegoose/typegoose'
import { BaseEntity, Tenant, generateEntityId } from '@ztechapps/common.contract'
import { HaulerRouteDetail } from './HaulerRouteDetail'

@ObjectType()
export class HaulerRoute extends BaseEntity {
  @Field(() => ID)
  @Prop({ type: String, required: true, default: () => generateEntityId('hrte') })
  declare _id: string

  @Field(() => Int, { nullable: true })
  @Prop({ type: Number })
  distance?: number

  @Field(() => Tenant, { nullable: true })
  declare tenant?: Tenant

  @Field(() => [HaulerRouteDetail], { nullable: true })
  @Prop({ type: [HaulerRouteDetail] }, PropType.ARRAY)
  details?: ReturnType<() => HaulerRouteDetail[]>
}
